import React from "react";

const ImageComponent = ({ src, alt, ...props }) => {
  return <img src={src} alt={alt} {...props} />;
};

export default ImageComponent;
